import { render, staticRenderFns } from "./ModifyRate.vue?vue&type=template&id=7436efd4&scoped=true"
import script from "./ModifyRate.vue?vue&type=script&lang=ts"
export * from "./ModifyRate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7436efd4",
  null
  
)

export default component.exports